module.exports = __webpack_public_path__ + "static/media/billsbot_and_scientist_lab.a1e7ba56.svg";